import React from "react";
import WidgetDemoFrame from "./widget-demo-frame";

const DemoPanel = ({scenario, height = 560, tint, className = ""}) => (
    <div
        className={`rounded-[10px] p-4 flex justify-center ${className}`}
        style={{background: tint || "var(--cl-surface-2)"}}
    >
        <div className="w-full max-w-[448px]">
            <WidgetDemoFrame scenario={scenario} height={height} autoplay/>
        </div>
    </div>
);

export default DemoPanel;
